import { Component } from '@angular/core';

@Component({
    selector: 'app-style-anl',
    templateUrl: './style-anl.component.html',
    styleUrls: ['./style-anl.component.scss'],
    standalone: false
})
export class StyleAnlComponent {

}
